export const GET_CAR_PRICE = "GET_CAR_PRICE";
